import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faClockRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { faPaperPlane } from "@fortawesome/free-regular-svg-icons";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import { useOutletContext } from "react-router-dom";
import AlertMessage from "../../Components/Alert/Alert";
import "./accounts.css";

const Accounts = () => {
	const { user } = useOutletContext();
	const { handleDrawerOpen } = useOutletContext();
	const [alertParams, setAlertParams] = useState({
		open: false,
		message: "",
		type: "",
	});
	const handleAlertClose = () => {
		setAlertParams({ ...alertParams, open: false });
	};
	return (
		<div className="accounts">
			<AlertMessage
				open={alertParams.open}
				message={alertParams.message}
				type={alertParams.type}
				onClose={handleAlertClose}
			/>
			<div className="accounts-table">
				<div className="accounts-table-title">
					<div className="accounts-table-title-item">
						<img src="/icons/usa.svg" alt="usa-icon" />
						<p className="accounts-table-title-text">Standard Аккаунт USD</p>
						<div className="accounts-table-title-icon">
							<FontAwesomeIcon icon={faCheck} />
						</div>
					</div>
				</div>
				<div className="accounts-table-info">
					<div className="accounts-table-info-item">
						<div className="accounts-table-info-item-left">
							<div className="accounts-table-info-item-left-params">
								<div className="accounts-table-info-item-left-params-item">
									STANDARD
								</div>
								<div className="accounts-table-info-item-left-params-item accounts-table-info-item-left-params-success">
									Выбраный Аккаунт
								</div>
							</div>
							<p className="accounts-table-info-item-left-text">Итоговый баланс</p>
							<p className="accounts-table-info-item-left-value">
								{user.balance.toFixed(2)} USD
							</p>
						</div>
						<div className="accounts-table-info-item-right">
							<div className="accounts-table-info-item-right-actions">
								<Button
									variant="contained"
									sx={{
										color: "#b7c4ff",
										backgroundColor: "#262c42",
										borderRadius: "100px",
										padding: "8px 15px ",
										fontSize: "16px",
										textTransform: "capitalize",
										display: "flex",
										alignItems: "center",
										letterSpacing: "0.15px",
										gap: "8px",
										lineHeight: "24px",
										fontWeight: "400",
										height: "38px",
									}}
									onClick={handleDrawerOpen}
								>
									<img
										src="/icons/dep.svg"
										alt="deposit-icon"
										style={{ width: "20px" }}
									/>
									Пополнить
								</Button>
								<Button
									variant="contained"
									sx={{
										color: "#b7c4ff",
										backgroundColor: "#262c42",
										borderRadius: "100px",
										padding: "8px 15px ",
										fontSize: "16px",
										textTransform: "capitalize",
										display: "flex",
										alignItems: "center",
										letterSpacing: "0.15px",
										gap: "8px",
										lineHeight: "24px",
										fontWeight: "400",
										height: "38px",
									}}
									onClick={() =>
										setAlertParams({
											open: true,
											type: "error",
											message: "Недостаточно средств для перевода",
										})
									}
								>
									<FontAwesomeIcon icon={faPaperPlane} />
									Отправить
								</Button>
							</div>
							<div className="accounts-table-info-item-right-info">
								<div className="accounts-table-info-item-right-info-item">
									<p className="accounts-table-info-item-right-info-item-title">
										Кредит
									</p>
									<p className="accounts-table-info-item-right-info-item-value">
										0.00 USD
									</p>
								</div>
								<Divider orientation="vertical" flexItem={true} />
								<div className="accounts-table-info-item-right-info-item">
									<p className="accounts-table-info-item-right-info-item-title">
										Инвестировано
									</p>
									<p className="accounts-table-info-item-right-info-item-value">
										{user.invested.toFixed(2)} USD
									</p>
								</div>
							</div>
						</div>
					</div>
					<div className="accounts-table-name">
						<FontAwesomeIcon icon={faClockRotateLeft} />
						История Транзакция
					</div>
					<div className="accounts-table-titles">
						<div className="accounts-table-titles-item">ID</div>
						<div className="accounts-table-titles-item">Дата</div>
						<div className="accounts-table-titles-item">Тип</div>
						<div className="accounts-table-titles-item">Сумма</div>
						<div className="accounts-table-titles-item">Валюта</div>
						<div className="accounts-table-titles-item">Статус</div>
					</div>
					<div className="accounts-table-rows">
						<img src="/icons/cloud.svg" alt="empty-icon" />
						<p className="accounts-table-rows-empty">Не найдено транзакций</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Accounts;
